import parse from 'html-react-parser';

const HtmlPrintBox = ({ value }) => {
 const printBoxStyle = {
    padding: "8px",
    lineHeight: "1.5rem",
    whiteSpace: "pre-wrap",
  }

  return (
    <div style={printBoxStyle} className='ql-editor'>{value && parse(value)}</div>
  )
}

export default HtmlPrintBox